import { render, staticRenderFns } from "./_launchGame.vue?vue&type=template&id=47d604d4&lang=pug&"
import script from "./_launchGame.vue?vue&type=script&lang=js&"
export * from "./_launchGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports